import { useEffect, useState } from "react";
import { NitroModules } from "react-native-nitro-modules";
import { toCalendars, toLocales } from "./map";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneDevice");
  return hybrid;
}
function getLocales() {
  return toLocales(native().getLocales());
}
function getCalendars() {
  return toCalendars(native().getCalendars());
}
function useLocales() {
  var [locales, setLocales] = useState(function() {
    return getLocales();
  });
  useEffect(function() {
    setLocales(getLocales());
    return native().addLocalizationListener(function() {
      return setLocales(getLocales());
    });
  }, []);
  return locales;
}
function useCalendars() {
  var [calendars, setCalendars] = useState(function() {
    return getCalendars();
  });
  useEffect(function() {
    setCalendars(getCalendars());
    return native().addLocalizationListener(function() {
      return setCalendars(getCalendars());
    });
  }, []);
  return calendars;
}
var Localization = Object.freeze({
  getLocales,
  getCalendars
});
export {
  Localization,
  useCalendars,
  useLocales
};
//# sourceMappingURL=index.native.js.map
